import { BiMeteor } from 'react-icons/bi';
import Button from 'react-bootstrap/Button';

export function DeleteButton({ children, ...rest }) {
    return (
        <Button variant="danger" size="sm" {...rest}>
          <BiMeteor/>
          {children}
        </Button>
    );
}
